import { render, staticRenderFns } from "./GRITableSkeleton.vue?vue&type=template&id=43c78201&scoped=true"
import script from "./GRITableSkeleton.vue?vue&type=script&lang=js"
export * from "./GRITableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./GRITableSkeleton.vue?vue&type=style&index=0&id=43c78201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c78201",
  null
  
)

export default component.exports